import produce from "immer";
import AuthService from '../AuthService';
import { EVO } from '../EVO';
import { urls } from "../urls";
import { defaultCronExpression } from "../defaultValues";

const GET_CRONEXPRESSIONS = 'peptalkr/CronExpressions/GET_CRONEXPRESSIONS';
const GET_CRONEXPRESSIONS_SUCCESS = 'peptalkr/CronExpressions/GET_CRONEXPRESSIONS_SUCCESS';
const GET_CRONEXPRESSIONS_FAILURE = 'peptalkr/CronExpressions/GET_CRONEXPRESSIONS_FAILURE';
const GET_CRONEXPRESSION_SUCCESS = 'peptalkr/CronExpressions/GET_CRONEXPRESSION_SUCCESS';

const ADD_CRONEXPRESSION = 'peptalkr/CronExpression/ADD_CRONEXPRESSION';
const ADD_CRONEXPRESSION_SUCCESS = 'peptalkr/CronExpression/ADD_CRONEXPRESSION_SUCCESS';
const ADD_CRONEXPRESSION_FAILURE = 'peptalkr/CronExpression/ADD_CRONEXPRESSION_FAILURE';

export const requestCronExpressions = () => ({ type: GET_CRONEXPRESSIONS });
export const receiveCronExpressions = (cronexpressions, id) => ({ type: GET_CRONEXPRESSIONS_SUCCESS, cronexpressions, id });
export const receiveCronExpressionsFail = error => ({ type: GET_CRONEXPRESSIONS_FAILURE, error });
export const receiveCronExpression = (cronexpression) => ({ type: GET_CRONEXPRESSION_SUCCESS, cronexpression });

export const addCronExpression = () => ({ type: ADD_CRONEXPRESSION });
export const addCronExpressionSuccess = expression => ({ type: ADD_CRONEXPRESSION_SUCCESS, expression });
export const addCronExpressionFailure = error => ({ type: ADD_CRONEXPRESSION_FAILURE, error });

export const fetchcronexpressions = (props) => (dispatch) => {
    let id = null;
    if (props && props.match && props.match.params && props.match.params.id) {
        id = props.match.params.id;
    }

    if (id && id === 'new') {
        dispatch(receiveCronExpression(defaultCronExpression))
    }
    else if (props && props.cronexpressions) {
        dispatch(receiveCronExpressions(props.cronexpressions, id))
    }
    else {
        const authService = new AuthService();
        if (authService.isAuthenticated()) {
            dispatch(requestCronExpressions());
            EVO.fetch(urls.api.cronexpressions.getAll)
                .then(cronexpressions => {
                    dispatch(receiveCronExpressions(cronexpressions, id));
                })
                .catch(error => dispatch(receiveCronExpressionsFail(error)));
        }
    }
};

export const addOrUpdateItem = (item) => (dispatch) => {
    if (AuthService.getInstance().isAuthenticated()) {
        dispatch(addCronExpression());
        return EVO.fetch(item.id ? urls.api.cronexpressions.update : urls.api.cronexpressions.add, item)
            .then(response => dispatch(addCronExpressionSuccess(response)))
            .catch(error => dispatch(addCronExpressionFailure(error)));
    }
};

const initialState = {
    cronexpressions: null,
    cronexpression: defaultCronExpression,
    loading: true,
    error: false
};

export default produce((draft, action) => {
    switch (action.type) {
        case GET_CRONEXPRESSIONS:
            draft.loading = true;
            return;
        case GET_CRONEXPRESSIONS_SUCCESS:
            draft.loading = false;
            draft.cronexpressions = action.cronexpressions;
            draft.cronexpression = EVO.getDetailsItemById(action.cronexpressions, action.id) || defaultCronExpression;
            return;
        case GET_CRONEXPRESSIONS_FAILURE:
            draft.loading = false;
            draft.error = action.error;
            return;
        case GET_CRONEXPRESSION_SUCCESS:
            draft.loading = false;
            draft.cronexpression = action.cronexpression;
            return;
        case ADD_CRONEXPRESSION:
            // nothing to do.. Formik handles it
            return;
        case ADD_CRONEXPRESSION_SUCCESS:
            draft.cronexpression = action.cronexpression;
            return;
        case ADD_CRONEXPRESSION_FAILURE:
            draft.error = action.error;
            return;
        default: return;
    }
}, initialState)


// WEBPACK FOOTER //
// ./src/redux/cronexpressions.js